import ReactDOM from 'react-dom/client';
import '@/assets/styles/fonts.css';
import '@/assets/styles/global.css';
import App from '@/app/App';
import packageJson from '../package.json';
import showVersion, { gitInfo } from '@/app/version';

// 顯示應用版本
// console.log('App', __GIT_INFO__);
if( !(gitInfo.branch === "master"
  || gitInfo.branch === "hotfix"
  || gitInfo.branch === "uat") ) {
  document.title = '(DEV) 中台 35 週年'
}
showVersion()

// 全域錯誤處理：抑制 MapLibre 的 AbortError
const originalError = console.error;
console.error = (...args) => {
  // 過濾掉 AbortError 相關的錯誤訊息
  const errorMsg = args[0]?.toString() || '';
  if (errorMsg.includes('signal is aborted') || errorMsg.includes('AbortError')) {
    return;
  }
  originalError.apply(console, args);
};

window.addEventListener('error', (event) => {
  if (event.error?.message?.includes('signal is aborted')) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return true;
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('signal is aborted')) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return true;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
